// @flow
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  GlobalOutlined,
  UserOutlined,
  PicCenterOutlined,
  DownOutlined,
  TagOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Avatar, Badge, Dropdown, message, Space } from 'antd';
import type { MenuProps } from 'antd';
import React, { useState, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './home.scss';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Device } from './subpages/device';
import { Group } from './subpages/group';
import { User } from './subpages/user';
import {Config} from "./subpages/config";
import {Log} from "../log";

type Props = {
  modifyUsername: () => void;
  username: string;
};

const items: MenuProps['items'] = [
  {
    label: '复制账号',
    key: '1',
  },
  {
    label: '退出登陆',
    key: '2',
  },
];

const Home = (props: Props) => {
  const { Header, Sider, Content } = Layout;
  const [collapsed, setCollapsed] = useState(false);
  let navigate = useNavigate();
  let { modifyUsername } = props;
  const username = localStorage.getItem('username') || ''
  const [content, setContent] = useState<React.ReactNode>(
    <Device username={username} />
  );
  const handleMenuClick = (key: string) => {
    switch (key) {
      case '1':
        setContent(<Device username={username} />);
        break;
      case '2':
        setContent(<Group username={username} />);
        break;
      case '3':
        // 可以在这里触发异步请求，根据需要更新内容
        setContent(<User />);
        break;
      case '4':
        // 可以在这里触发异步请求，根据需要更新内容
        setContent(<Config />);
        break;
      case '5':
        // 可以在这里触发异步请求，根据需要更新内容
        setContent(<Log />);
        break;
      default:
        break;
    }
  };

  if (!localStorage.getItem('username') || localStorage.getItem('username')?.length === 0) {
    navigate('/');
    localStorage.removeItem('Authorization');
  }

  useLayoutEffect(() => {
    // checkToken().then((e: any) => {
    //   if (e.code === -2004) {
    //     message.error('请重新登陆');
    //     navigate('/');
    //   }
    // });
  }, []);

  function copyToClipboard(textToCopy: string) {
    // 创建一个临时的文本区域元素
    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;

    // 防止在页面上滚动到元素
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    // 将文本区域元素添加到页面中
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      // 执行复制命令
      const successful = document.execCommand('copy');
      if (successful) {
        message.success('复制成功');
      } else {
        message.error('复制失败');
      }
    } catch (err) {
      message.error('复制出错');
    }

    // 移除临时创建的文本区域元素
    document.body.removeChild(textArea);
  }

  // 使用函数

  const onClick: MenuProps['onClick'] = ({ key }) => {
    if (key === '1') {
      const textToCopy = username;
      if (navigator.clipboard) {
        // 复制文本到剪贴板
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            message.success('复制成功');
          })
          .catch(err => {
            message.error('复制失败');
          });
      } else {
        copyToClipboard(textToCopy);
      }
    } else {
      localStorage.removeItem('Authorization');
      modifyUsername();
      navigate('/');
    }
  };

  return (
    <div className="home">
      <Layout className="home_layout" style={{}}>
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <div className="logo">SnapEmu管理系统</div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={['1']}
            onClick={({ key }) => handleMenuClick(key)}
            items={[
              {
                key: '1',
                icon: <GlobalOutlined />,
                label: '设备管理',
              },
              {
                key: '2',
                icon: <PicCenterOutlined /> ,
                label: '组管理',
              },
              {
                key: '3',
                icon: <UserOutlined />,
                label: '用户管理',
              },
              {
                key: '4',
                icon: <PicCenterOutlined />,
                label: '全局配置',
              },
              {
                key: '5',
                icon: <TagOutlined />,
                label: '日志管理',
              },
            ]}
          />
        </Sider>
        <Layout className="site-layout">
          <Header
            className="site-layout-background"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div>
              {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: 'trigger',
                  onClick: () => setCollapsed(!collapsed),
                }
              )}
            </div>
            <div>
              <Badge>
                <Avatar shape="square" icon={<UserOutlined />} />
              </Badge>
              <span style={{ marginLeft: '10px' }}>
                <Dropdown menu={{ items, onClick }}>
                  <a onClick={e => e.preventDefault()}>
                    <Space>
                      {username}
                      <DownOutlined />
                    </Space>
                  </a>
                </Dropdown>
              </span>
            </div>
          </Header>
          <Content
            className="site-layout-content"
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
            }}
          >
            {content}
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  username: state.username, // 假设 count 是根状态中的一部分
});

// 映射 dispatch 到组件 props
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    modifyUsername: () => dispatch({ type: 'modifyUsername', username: '' }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
